import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "product-box"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "image-slot"
}, null, -1);
const _hoisted_3 = {
  key: 0,
  class: "more"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_TwoLinesText = _resolveComponent("TwoLinesText");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
    class: "product-img",
    src: !!$props.model ? require('@/assets/products/' + $props.model + '.jpg') : $props.img,
    fit: "cover",
    lazy: $props.lazy
  }, {
    placeholder: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["src", "lazy"]), _createVNode(_component_TwoLinesText, {
    name: $props.name
  }, null, 8, ["name"]), !$props.model ? (_openBlock(), _createElementBlock("p", _hoisted_3, "More >>")) : _createCommentVNode("", true)]);
}